import { store } from '../redux/store'; // Adjust the path to your Redux store
import { logout } from '../redux/reducers/authReducers'
import { notification } from 'antd';

export const onRequest = async (config) => {

    const controller = new AbortController();
    if (config.url && config.url.indexOf("login") < 0) {
    }
  
    return {
      ...config,
      signal: controller.abort(),
    };
};

export const onRequestError = (error) => {
  if (error.response === undefined) {
  }
  return error;
};

export const onResponse = (response) => {
    if (response) {
      if (response.data) {
        return response.data;
      } else return response;
    }
};

export const onResponseError = (error) => {

    if(error.response === undefined) {
      // notification.error({ message: error.message });
      return;
    } else if (error.response.status === 401) {
      console.log("error.request", error.request);
      console.log("error.response", error.response);
  
      if (
        error?.response?.config?.url &&
        error?.response?.config?.url?.indexOf("login") < 0
      ) {
      } else {
        return;
      }
  
      return;
    } else if (error.response.status === 400) {
      // notification.error({ message: errorMessage });
      return error.response.data;
    } else if (error.response.status === 403) {
      store.dispatch(logout());
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);

      if(error?.response?.data?.subscriptionExpired){
        notification.error({
          message: "Your subscription has expired.",
          description: "Redirecting to login page...",
          duration: 5,
        })
      }

    } else if (error.response.status === 500) {
      return error.response.data

      // notification.error({ message: error.message });
      return;
    }else if(error.response.status === 422){
      return error.response.data
    }else if(error.response.status === 404){
      return error.response.data
    }
     else {
      // notification.error({ message: errorMessage });
      return;
    }
    return error;
};